import { onAuthStateChanged } from 'firebase/auth';
import { useEffect } from 'react';
import { auth } from '../firebase';

const useFirebaseAuthMonitor = () => {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
    });

    return () => unsubscribe();
  }, []);
};

export default useFirebaseAuthMonitor;